<template>
  <div
    class="card card--no-shadow border-0"
    :style="{ backgroundColor: bgColor }"
  >
    <div class="card-content">
      <div class="card-body p-1">
        <div class="media d-flex position-relative">
          <div class="media-body text-left">
            <h4 class="card-value mb-1" :style="{ color: valueColor }">
              <span v-if="currency">&#8358;</span> {{ value }}
            </h4>
            <h6 class="card-text mb-1" :style="{ color: textColor }">
              {{ text }}
            </h6>
            <router-link
              to="#"
              class="button btn-sm card-button d-none"
              event=""
              >View All</router-link
            >
          </div>
          <div class="position-absolute card-img">
            <img :src="cardImg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: false,
      default: "Card Title"
    },
    value: {
      type: [String, Number],
      required: false,
      default: "0"
    },
    bgColor: {
      type: String,
      required: false,
      default: "#fff"
    },
    textColor: {
      type: String,
      required: false,
      default: "#001833"
    },
    valueColor: {
      type: String,
      required: false,
      default: "#001833"
    },
    currency: {
      type: Boolean,
      required: false
    },
    cardImg: {
      type: String,
      required: false
    }
  }
};
</script>

<style scoped>
.card-text {
  font-family: "AvenirNextW15-Demi";
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.7px;
}

.card-value {
  font-family: "AvenirNextW15-Demi";
  font-size: 30px;
  letter-spacing: 1px;
  line-height: 1;
}

.card-button {
  font-size: 0.8rem !important;
  padding: 0.8rem !important;
  background: white !important;
  color: #000 !important;
}

.card-img {
  bottom: -2.5rem;
  width: 64px;
  height: 64px;
  left: -2rem;
}

.card-img img {
  opacity: 0.5;
}
</style>
